"use strict";

var _interopRequireWildcard = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _toConsumableArray2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
var _auth = require("@/utils/auth");
var _router = _interopRequireWildcard(require("@/router"));
var _store = _interopRequireDefault(require("@/store"));
// import { login, logout, getInfo } from '@/http/interface'

var defaultSettings = require("../../settings.js");
var state = {
  userInfo: {},
  token: '',
  sasToken: '',
  sasTokenExpiredTime: '',
  systemList: [],
  currentSysInfo: {},
  name: '',
  avatar: '',
  roles: [],
  teamType: ''
};
var mutations = {
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_SASTOKEN: function SET_SASTOKEN(state, sasToken) {
    state.sasToken = sasToken;
  },
  SET_SASTOKEN_EXPIRED_TIME: function SET_SASTOKEN_EXPIRED_TIME(state, sasTokenExpiredTime) {
    state.sasTokenExpiredTime = sasTokenExpiredTime;
  },
  SET_SYSTEM_LIST: function SET_SYSTEM_LIST(state, token) {
    state.systemList = (0, _toConsumableArray2.default)(token);
  },
  SET_CURRENT_SYSTEM_INFO: function SET_CURRENT_SYSTEM_INFO(state, system) {
    state.currentSysInfo = (0, _objectSpread2.default)({}, system);
    var systemName = _store.default.getters.currentSysInfo.systemName;

    // set page title
    document.title = systemName || defaultSettings.title || 'SFE管理后台';
  },
  SET_USER_INFO: function SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = avatar;
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  },
  SET_TEAM_TYPE: function SET_TEAM_TYPE(state, teamType) {
    state.teamType = teamType;
  }
};
var actions = {
  // user setToken
  setToken: function setToken(_ref, token) {
    var commit = _ref.commit;
    commit('SET_TOKEN', token);
    if (token) {
      (0, _auth.setToken)(token);
    }
  },
  // set sasToken
  setSasToken: function setSasToken(_ref2, sasToken) {
    var commit = _ref2.commit;
    commit('SET_SASTOKEN', sasToken);
  },
  // set sasToken expired time
  setSasTokenExpiredTime: function setSasTokenExpiredTime(_ref3, sasTokenExpiredTime) {
    var commit = _ref3.commit;
    commit('SET_SASTOKEN_EXPIRED_TIME', sasTokenExpiredTime);
  },
  // set system list
  setSystemList: function setSystemList(_ref4, data) {
    var commit = _ref4.commit;
    commit('SET_SYSTEM_LIST', data);
  },
  // set current system
  setCurrentSystemInfo: function setCurrentSystemInfo(_ref5, data) {
    var commit = _ref5.commit;
    commit('SET_CURRENT_SYSTEM_INFO', data);
    if (data && data.appIdentification) {
      (0, _auth.setSystem)(data.appIdentification);
    }
  },
  // get user info
  setInfo: function setInfo(_ref6, data) {
    var commit = _ref6.commit;
    var userName = data.userName,
      avatar = data.avatar;
    // commit('SET_ROLES', roles)
    commit('SET_USER_INFO', data);
    commit('SET_NAME', userName);
    commit('SET_AVATAR', avatar);
  },
  setRoles: function setRoles(_ref7, data) {
    var commit = _ref7.commit;
    commit('SET_ROLES', data);
  },
  setTeamType: function setTeamType(_ref8, data) {
    var commit = _ref8.commit;
    commit('SET_TEAM_TYPE', data);
  },
  // user logout
  logout: function logout(_ref9) {
    var commit = _ref9.commit,
      dispatch = _ref9.dispatch;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', '');
      commit('SET_CURRENT_SYSTEM_INFO', '');
      // commit('SET_ROLES', [])
      (0, _auth.removeToken)();
      (0, _auth.removeSystem)();
      (0, _router.resetRouter)();

      // reset visited views and cached views
      // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
      dispatch('nocache/setAddRoute', {
        isAddRoute: false
      }, {
        root: true
      });
      dispatch('tagsView/delAllViews', null, {
        root: true
      });
      resolve();
    });
  },
  // remove token
  resetToken: function resetToken(_ref0) {
    var commit = _ref0.commit;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', '');
      commit('SET_CURRENT_SYSTEM_INFO', '');
      // commit('SET_ROLES', [])
      (0, _auth.removeToken)();
      (0, _auth.removeSystem)();
      resolve();
    });
  },
  // dynamically modify permissions
  changeRoles: function changeRoles(_ref1, role) {
    var commit = _ref1.commit,
      dispatch = _ref1.dispatch;
    return new Promise(/*#__PURE__*/function () {
      var _ref10 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(resolve) {
        var token, _yield$dispatch, roles, accessRoutes;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              token = role + '-token';
              commit('SET_TOKEN', token);
              (0, _auth.setToken)(token);
              _context.n = 1;
              return dispatch('getInfo');
            case 1:
              _yield$dispatch = _context.v;
              roles = _yield$dispatch.roles;
              (0, _router.resetRouter)();

              // generate accessible routes map based on roles
              _context.n = 2;
              return dispatch('permission/generateRoutes', roles, {
                root: true
              });
            case 2:
              accessRoutes = _context.v;
              // dynamically add accessible routes
              _router.default.addRoutes(accessRoutes);

              // reset visited views and cached views
              dispatch('tagsView/delAllViews', null, {
                root: true
              });
              resolve();
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref10.apply(this, arguments);
      };
    }());
  }
};
var _default = exports.default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};